export default __webpack_public_path__ + "static/media/planet.aec32de6.svg";